import { GenerateFormFieldDataModel } from "src/app/model";

export interface FilterInputDataPayloadModel {
  filterInputs: string[];
  type: number;
}

export interface RightMenuAction {
  filterStatus: boolean;
  filterData: GenerateFormFieldDataModel[];
}